import type { ApiAddressSuggestion } from './address-suggestions'

export class ICustomer {
  constructor(
    public hasBeenSetFromVipps: boolean = false,
    public isVippsUser: boolean = false,
    public firstName: string = '',
    public lastName: string = '',
    public email: string = '',
    public phone: string = '',
    public billingAddress?: ApiAddressSuggestion,
    public deliveryAddress?: ApiAddressSuggestion,
  ) {}
}
